import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getLocalizedAssetUrl } from 'helpers/utils/utilities';

const LocalizedVideo = ({
  locale = 'en',
  assetName,
  ext = 'mp4',
  className,
  style,
  ...rest
}) => {
  const [videoSrc, setVideoSrc] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    getLocalizedAssetUrl(locale, assetName, ext)
      .then(setVideoSrc)
      .catch((err) => {
        console.error('Failed to load localized video:', err);
      });
  }, [locale, assetName, ext]);

  if (!videoSrc) return null;

  return (
    <video
      className={className}
      style={style}
      controls
      {...rest}
    >
      <source src={videoSrc} type={`video/${ext}`} />
      { t("Your browser does not support the video tag.") }
    </video>
  );
};

export default LocalizedVideo;